import { IGetVenuesResponseData } from 'src/api/getVenues/types';
import { toIsoTimestamp } from 'src/helpers/toIsoTimestamp/toIsoTimestamp';

export interface ILiveMenu {
  menuId: string;
  name: string;
  venueNames: string[];
  channelNames: string[];
  lastPublishedDate: string;
}

/**
 * Unparseable values fall back to 0 so they sort oldest rather than producing NaN.
 */
const toEpoch = (value: string): number => {
  const ms = Date.parse(toIsoTimestamp(value));
  return Number.isNaN(ms) ? 0 : ms;
};

/**
 * Aggregates the menus that are currently published, across all venues and
 * channels, from the published_channels already returned by GET /venues.
 */
export const getLiveMenus = (venues: IGetVenuesResponseData[]): ILiveMenu[] => {
  const liveMenus = new Map<string, ILiveMenu>();

  venues.forEach((venue) => {
    (venue.published_channels ?? []).forEach((channel) => {
      channel.menus.forEach((menu) => {
        const existing = liveMenus.get(menu.menu_id) ?? {
          menuId: menu.menu_id,
          name: menu.name,
          venueNames: [],
          channelNames: [],
          lastPublishedDate: menu.last_published_date,
        };

        if (!existing.venueNames.includes(venue.name)) existing.venueNames.push(venue.name);
        if (!existing.channelNames.includes(channel.name)) existing.channelNames.push(channel.name);
        if (toEpoch(menu.last_published_date) > toEpoch(existing.lastPublishedDate)) {
          existing.lastPublishedDate = menu.last_published_date;
        }

        liveMenus.set(menu.menu_id, existing);
      });
    });
  });

  return [...liveMenus.values()].sort((a, b) => toEpoch(b.lastPublishedDate) - toEpoch(a.lastPublishedDate));
};
